/** @hidden */
export interface IDrawContext {
}
